import { createFileRoute } from "@tanstack/react-router";

import Developer from "../pages/Developer";
import { RequireAuth } from "../utils/RequireAuth";

function parseDeveloperSearch(search: Record<string, unknown>) {
  return {
    tab:
      search.tab === "webhooks"
        ? ("webhooks" as const)
        : search.tab === "signed-metadata"
          ? ("signed-metadata" as const)
          : ("api-keys" as const),
    environment: typeof search.environment === "string" ? search.environment : undefined,
    // The webhook sub-view, so a link can open Webhooks › Events.
    view: search.view === "events" ? ("events" as const) : undefined,
  };
}

export const Route = createFileRoute("/_shell/developer")({
  validateSearch: parseDeveloperSearch,
  component: DeveloperRoute,
});

function DeveloperRoute() {
  return (
    <RequireAuth require="chatbotAccess">
      <Developer />
    </RequireAuth>
  );
}
